import React, { useEffect, useRef, useState } from 'react';
import { post } from '../Auths/AuthToken';
import setUiMessage from '../../Utilities/Tostify';
import CounselingAccordion from '../Patient/CounselingAccordion';
import CounselingSecColSubChild from '../Patient/CounselingSecColSubChild';
import ConfirmDialog from '../../Utilities/ConfirmDialog';
import SubTypePopup from '../Patient/SubTypePopup';
import { handleCounsellingFormMidItem } from '../../httpdata/appointmentsdata';

import ReactDatePicker from 'react-datepicker';
import { DEFAULT_DATE_FORMATE } from '../../constents';
import { format } from 'date-fns';
import AddSubValPopup from '../Patient/AddSubValPopup';
import { useDispatch, useSelector } from 'react-redux';
import { handleGlobalReload } from '../../redux/slices/appSlice';

function AddNote({ patId = 0, soapId = 0, handleClose = () => {} }) {
  const scrollRefs = useRef([]);
  const checkboxRef = useRef([]);

  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);
  const { globalReload } = useSelector((store) => store.app);

  const [allData, setAllData] = useState(false);
  const [loading, setLoading] = useState(false);

  const [accord, seAccord] = useState({});
  const [textAreaData, setTextAreaDataData] = useState({});
  const [checkBoxData, setCheckBoxData] = useState({});
  const [showHideChiled, setShowHideChiled] = useState('1_2');
  const [classFirstCol, setClassFirstCol] = useState('1_2');

  const [checkedAll, setCheckedAll] = useState({});
  const [childSerch, setChildSerch] = useState({});
  const [addSubChild, setAddSubChild] = useState(false);

  const [subTypePopup, setSubTypePopup] = useState(false);
  const [subChildPrams, setSubChildPrams] = useState([]);
  const [removeSubChild, setRemoveSubChild] = useState(false);
  const [sucPrams, setSucPrams] = useState('');
  const [catAndId, setCatAndId] = useState('1_2');
  const [provider, setProvider] = useState('');
  const [startDate, setStartDate] = useState(new Date());

  const [editSubChild, setEditSubChild] = useState({
    status: false,
    data: null,
  });

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const response = await post('api/notes/ProgressNote/getNotesData', {
          patId: patId,
          soapId: soapId,
        });
        if (response.status === 200) {
          setAllData(response?.data);
          setLoading(false);
          if (response?.data?.soapDetail) {
            setProvider(response?.data?.soapDetail?.provider_id);
            setStartDate(
              new Date(response?.data?.soapDetail?.consult_date) || null
            );
          } else {
            setProvider(user?.user_type === '1' ? user?.id : '');
          }

          const formDatas = response?.data?.therapyMasterData?.reduce(
            (acc, data) => {
              data[2]?.forEach((subData) => {
                const key = `therapyDetailsText_${data[3]}_${subData[0]}`;
                acc[key] = subData[3];
              });
              return acc;
            },
            {}
          );

          const chkInptData = response?.data?.therapyMasterData?.reduce(
            (acc, data, i) => {
              data[2] &&
                data[2]?.forEach((subData, m) => {
                  if (m === 0 && i === 0) {
                    seAccord(data[3]);
                    setShowHideChiled(`${data[3]}_${subData[0]}`);
                    setClassFirstCol(`${data[3]}_${subData[0]}`);
                  }

                  if (subData[4] === 'dx' && response?.data?.probArr) {
                    for (let f in response?.data?.probArr) {
                      const key = `ptcSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.probArr[f]?.dxId}`;

                      acc[key] = false;
                    }
                  } else if (
                    subData[4] === 'focus' &&
                    response?.data?.golObjData
                  ) {
                    for (let f in response?.data?.golObjData) {
                      const key = `ptcSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.golObjData[f]?.goalId}`;

                      acc[key] = false;
                    }
                  } else {
                    subData[2] &&
                      subData[2]?.forEach((subChildData) => {
                        const key = `ptcSubChildDataListInpt_${data[3]}_${subData[0]}_${subChildData['child_id']}`;
                        acc[key] =
                          subChildData?.is_checked === '1' ? true : false;
                      });
                  }
                });
              return acc;
            },
            {}
          );

          setCheckBoxData(chkInptData);
          setTextAreaDataData(formDatas);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [patId, soapId, user?.id, user?.user_type]);

  useEffect(() => {
    if (childSerch[catAndId]) {
      let userInput = childSerch[catAndId]?.replace(/\\/g, '').toLowerCase();
      let secCol = document.querySelectorAll(
        '.ptcMasterSubChildData_' + catAndId
      );
      secCol.forEach(function (element, i) {
        let searchTerm = element.getAttribute('data-search-term').toLowerCase();
        if (searchTerm.search(userInput) === -1) {
          element.classList.add('hide');
        } else {
          element.classList.remove('hide');
        }
      });
    } else {
      const elements = document.querySelectorAll(
        '.ptcMasterSubChildData_' + catAndId
      );
      elements.forEach((element) => {
        element.classList.remove('hide');
      });
    }
  }, [childSerch, catAndId]);

  const handleCheckBoxLable = (eleId, data) => {
    if (data && parseInt(data?.sub_type) === 1) {
      handleSubTypePopup(data);
      setSubChildPrams([eleId, data]);
    } else {
      const target = checkboxRef.current[eleId];
      let checked = !target.checked;
      handleCheckBoxChangeComn(eleId, checked);
      setCheckBoxData({
        ...checkBoxData,
        [eleId]: checked ? true : false,
      });
    }
  };

  const selectAll = (e, id) => {
    const { checked } = e.target;
    setCheckedAll({ ...checkedAll, [id]: checked ? true : false });

    let secColdata = document.querySelectorAll('.ptcMasterSubChildData_' + id);
    let finalText = '';
    secColdata.forEach(function (element, i) {
      let idArr = element.getAttribute('id').split('_');
      let selStr = document.getElementById(
        'ptcSubChildDataList_' + idArr[1] + '_' + idArr[2] + '_' + idArr[3]
      ).textContent;

      if (checked) {
        checkBoxData[element.getAttribute('id')] = checked;
        finalText += selStr + '\n';
      } else {
        checkBoxData[element.getAttribute('id')] = checked;
      }
    });
    finalText = finalText.slice(0, -2);
    setTextAreaDataData({
      ...textAreaData,
      ['therapyDetailsText_' + id]: finalText,
    });
  };

  const handleChildSerch = (e, id) => {
    const { value } = e.target;
    setChildSerch({});
    setChildSerch({ ...childSerch, [id]: value });
  };

  const handleCheckBoxChange = (e, data) => {
    const { id, checked } = e.target;
    if (checked && data && parseInt(data?.sub_type) === 1) {
      handleSubTypePopup(data);
      setSubChildPrams([e.target.id, data]);
      setCheckBoxData({
        ...checkBoxData,
        [e.target.id]: true,
      });
    } else {
      setCheckBoxData({
        ...checkBoxData,
        [id]: checked ? true : false,
      });
      handleCheckBoxChangeComn(id, checked);
    }
  };

  const handleSubTypePopup = (data) => {
    setSubTypePopup(true);
  };

  const handleCheckBoxChangeComn = (id, checked) => {
    const idArr = id?.split('_');

    let selStr = document?.querySelector(
      '#ptcSubChildDataList_' + idArr[1] + '_' + idArr[2] + '_' + idArr[3]
    ).textContent;

    let resSelStr = document?.querySelector(
      '#ptcdiagReason_' + idArr[1] + '_' + idArr[2] + '_' + idArr[3]
    ).textContent;

    if (resSelStr !== 'undefined') {
      selStr += resSelStr ? '\n' + resSelStr : '';
    }

    let textData =
      textAreaData['therapyDetailsText_' + idArr[1] + '_' + idArr[2]];
    if (checked) {
      textData = textData?.replace(selStr, '');
      textData = textData?.replace(/^,*\s*|,*\s*$/, '');
      setTextAreaDataData({
        ...textAreaData,
        ['therapyDetailsText_' + idArr[1] + '_' + idArr[2]]: textData
          ? textData + '\n' + selStr
          : selStr,
      });
    } else {
      if (textData?.indexOf('\n' + selStr) === -1) {
        textData = textData?.replace(selStr + '\n', '');
      } else {
        textData = textData?.replace('\n' + selStr, '');
      }
      textData = textData?.replace(selStr, '');
      textData?.replace(/^,*\s*|,*\s*$/, '');

      setTextAreaDataData({
        ...textAreaData,
        ['therapyDetailsText_' + idArr[1] + '_' + idArr[2]]: textData,
      });
    }
  };

  const handleRemoveSubChild = (id) => {
    setRemoveSubChild(true);
    setSucPrams(id);
  };

  const handleEditSubChild = (id) => {
    setEditSubChild({ ...editSubChild, status: true, data: id });
  };

  const handleSubDataShow = (id) => {
    setShowHideChiled(id);
    setClassFirstCol(id);
    setCatAndId(id);
    const target = scrollRefs.current['therapyDetailsText_' + id];
    target.scrollIntoView({ behavior: 'smooth' });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTextAreaDataData({ ...textAreaData, [name]: value });
  };

  const handleRemoveSubChildConfirm = async (id) => {
    const idArr = id.split('_');
    const itemId = idArr[2];
    if (itemId) {
      const response = await handleCounsellingFormMidItem(itemId, 'phoneNote');
      if (response?.status === 200) {
        if (response.data.message === 'success') {
          setUiMessage('suc', 'Record deleted successfully.');
          setCheckBoxData({
            ...checkBoxData,
            ['ptcSubChildDataListInpt_' + id]: false,
          });
          const split = id?.split('_');
          const selStr = document?.querySelector(
            '#ptcSubChildDataList_' + id
          ).innerHTML;

          let textData =
            textAreaData['therapyDetailsText_' + split[0] + '_' + split[1]];

          if (textData?.indexOf('\n' + selStr) === -1) {
            textData = textData?.replace(selStr + '\n', '');
          } else {
            textData = textData?.replace('\n' + selStr, '');
          }

          //textData = textData?.replace(selStr, '');
          textData?.replace(/^,*\s*|,*\s*$/, '');
          setTextAreaDataData({
            ...textAreaData,
            ['therapyDetailsText_' + split[0] + '_' + split[1]]: textData,
          });

          const element = document.querySelector(
            '#ptcSubChildDataListInpt_' + id
          );
          element.remove();
          setRemoveSubChild(false);
        }
      } else {
        setUiMessage('err', 'Something went wrong.');
      }
    }
  };

  const handlesubtypeform = (id, data) => {
    const idArr = id?.split('_');
    let textData =
      textAreaData['therapyDetailsText_' + idArr[1] + '_' + idArr[2]];
    //if (checked) {
    textData = textData?.replace(data, '');
    textData = textData?.replace(/^,*\s*|,*\s*$/, '');
    setTextAreaDataData({
      ...textAreaData,
      ['therapyDetailsText_' + idArr[1] + '_' + idArr[2]]: textData
        ? textData + '\n' + data
        : data,
    });
    //}

    setCheckBoxData({
      ...checkBoxData,
      [id]: true,
    });
  };

  const noteDataJson = () => {
    let masterArr = [];
    let hisAndSymMaster = document.querySelectorAll(
      '.parnt-actv-tb .therapyAddEditSection'
    );
    let retStr = false;
    if (hisAndSymMaster) {
      hisAndSymMaster.forEach(function (element) {
        const masterId = element.getAttribute('value');
        let masterText = document.querySelector(
          '#therapyDetailsText_' + masterId
        ).value;

        let hisAndSymChield = document.querySelectorAll(
          '.ptcMasterSubChildData_' + masterId
        );

        let childArr = [];
        hisAndSymChield.forEach(function (element, i) {
          let childIdTextArr = element.getAttribute('id').split('_');
          let subTypeVal = element.getAttribute('attr')
            ? element.getAttribute('attr')
            : '0';

          let childText = document.getElementById(
            'ptcSubChildDataList_' + masterId + '_' + childIdTextArr[3]
          ).textContent;

          childArr.push({
            masterId: masterId,
            childId: childIdTextArr[3],
            childText: childText.trim(),
            childInput: checkBoxData[element.getAttribute('id')] ? '1' : '0', //isChecked ? '1' : '0',
            childSubKey: subTypeVal,
          });
        });
        masterArr.push({
          masterId: masterId,
          masterText: masterText,
          childArr: childArr,
        });
      });
      retStr = JSON.stringify(masterArr);
    }
    return retStr;
  };

  const handleNoteFormSave = async () => {
    if (!provider) {
      setUiMessage('err', 'Plrease select provider.');
      return;
    }
    try {
      const response = await post('api/notes/progressNote/saveAddNoteForm', {
        patId: patId,
        staffUserId: user?.id,
        phoneNoteResource: provider,
        phoneNoteDate: format(startDate, DEFAULT_DATE_FORMATE),
        noteCategoryId: accord,
        noteDataJson: noteDataJson(),
      });
      if (response.status === 200) {
        dispatch(handleGlobalReload(!globalReload));
        handleClose();
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleNoteFormUpdate = async () => {
    if (!provider) {
      setUiMessage('err', 'Plrease select provider.');
      return;
    }
    try {
      const response = await post('api/notes/progressNote/updateAddNoteForm', {
        patId: patId,
        soapId: soapId,
        phoneNoteResource: provider,
        phoneNoteDate: format(startDate, DEFAULT_DATE_FORMATE),
        staffUserId: user?.id,
        noteDataJson: noteDataJson(),
      });
      if (response.status === 200) {
        dispatch(handleGlobalReload(!globalReload));
        handleClose();
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleCalbackData = (data, catagory, i, j, subTypeSection, mode) => {
    setCheckBoxData({
      ...checkBoxData,
      [`ptcSubChildDataListInpt_${data[0]}_${data[1]}_${data[2]}`]: false,
    });

    const updatedData = [...allData?.therapyMasterData];
    if (mode === 'add') {
      const newObj = {
        child_id: data[2],
        child_texte: catagory,
        sub_type: subTypeSection ? '1' : '0',
      };
      if (updatedData[i][2][j][2]) {
        updatedData[i][2][j][2].push(newObj);
      } else {
        updatedData[i][2][j][2] = [newObj];
      }
    } else {
      const newObjIndex = updatedData[i][2][j][2].findIndex(
        (obj) => obj.child_id === data[2]
      );
      if (newObjIndex !== -1) {
        updatedData[i][2][j][2][newObjIndex].child_texte = catagory;
        updatedData[i][2][j][2][newObjIndex].sub_type = subTypeSection
          ? '1'
          : '0';
        // You can update other properties as well
      }
    }
    //setAllData(updatedData);
  };

  return (
    <div className="modalBackground">
      <div
        className="pie-note-blk subsequent-counseling thrnst-nw-cnslng"
        style={{
          height: '567px',
          top: 'unset',
          left: 'unset',
          width: '1000px',
        }}
      >
        {loading && (
          <div
            style={{
              width: '100%',
              height: '100%',
              background: '#ccc',
              position: 'absolute',
              opacity: '.5',
              zIndex: '10000',
              display: ' flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <span style={{ fontSize: '18px' }}>Loading...</span>
          </div>
        )}
        <div
          className="asmnt-prnt-blk-hdr"
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            gap: '20',
          }}
        >
          <div className="appt-hx-fa-rw">
            <span className="clear5 clear-right">Add Note:</span>
            <span
              className="label clear-right clear5"
              style={{ marginLeft: '100px' }}
            >
              Provider:<span className="red">*</span>
            </span>
            <span className="value clear-right" style={{ width: '250px' }}>
              <select
                className="book-appt-dd width100"
                data-placeholder="Select Provider"
                value={provider}
                onChange={(e) => setProvider(e.target.value)}
              >
                <option value="">{''}</option>
                {allData?.providerList?.map((data, i) => (
                  <option key={i} value={data?.id}>
                    {data?.providerName}
                  </option>
                ))}
              </select>
            </span>
            <span
              className="label clear-right clear5"
              style={{ marginLeft: '20px' }}
            >
              Date:<span className="red">*</span>
            </span>
            <span className="value" style={{ width: '90px' }}>
              <ReactDatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                dateFormat={DEFAULT_DATE_FORMATE}
                className="app-date-picker"
              />
            </span>
          </div>
          <span className="right bold cursor" onClick={handleClose}>
            X
          </span>
        </div>

        <div
          className="asmnt-prnt-blk-bdy phone-note"
          style={{ height: '490px' }}
        >
          <div className="asmnt-blk-2">
            {/*
			<div
              className="asmnt-childblk blk2-col1 fr-single-prnt overflow"
            >
				{allData?.therapyMasterData?.map((data, r) => (
				<span className={`mat-cnslng-prnt-val therapyAddEditSection_${data[3]}_${data[2][0][0]}`} value={`${data[3]}_${data[2][0][0]}`}>Phone Note</span>
				))}
			</div>*/}

            <div className="asmnt-childblk blk2-col1 fr-single-prnt overflow">
              {allData?.therapyMasterData?.map((data, r) => (
                <CounselingAccordion
                  key={r}
                  classFirstCol={classFirstCol}
                  accord={accord}
                  handleSubDataShow={handleSubDataShow}
                  parent={data}
                  handleClick={(id) => {
                    seAccord(data[3]);
                    handleSubDataShow(data[3] + '_' + data[2][0][0]);
                  }}
                  moduleName={'therapyAddEditSection'}
                  unHide={'un'}
                />
              ))}
            </div>
            <div
              className="asmnt-childblk blk2-col2"
              style={{ height: 'auto' }}
            >
              {allData?.therapyMasterData?.map((data, i) => (
                <div key={i}>
                  {data[2] &&
                    data[2]?.map((subData, j) => (
                      <div
                        key={j}
                        id={'ptcSubChildBox_' + data[3] + '_' + subData[0]}
                        className={
                          showHideChiled === data[3] + '_' + subData[0]
                            ? ''
                            : 'hide'
                        }
                        style={{ height: '100%' }}
                      >
                        <div className="sec-col-serch">
                          <span className="clear5 clear-left10">
                            <input
                              type="checkbox"
                              checked={
                                checkedAll[data[3] + '_' + subData[0]] || ''
                              }
                              onChange={(e) =>
                                selectAll(e, data[3] + '_' + subData[0])
                              }
                            />
                          </span>
                          <span className="clear-left10">
                            <input
                              type="search"
                              className="cnslng-fu-chld-srch"
                              placeholder="Search here..."
                              value={
                                childSerch[data[3] + '_' + subData[0]] || ''
                              }
                              onChange={(e) =>
                                handleChildSerch(e, data[3] + '_' + subData[0])
                              }
                            />
                            <span
                              className="add-new-chld-item"
                              title="Add new values"
                              onClick={() => setAddSubChild(true)}
                            >
                              +
                            </span>
                          </span>
                          {addSubChild && (
                            <AddSubValPopup
                              closeDialog={() => setAddSubChild(false)}
                              masCatId={data[3]}
                              masterId={subData[0]}
                              childId={''}
                              handleCalbackData={handleCalbackData}
                              catIndex={i}
                              subCatIndex={j}
                              formName="phoneNote"
                              heading={subData[1]}
                            />
                          )}
                          {editSubChild.status && (
                            <AddSubValPopup
                              closeDialog={() =>
                                setEditSubChild({
                                  ...editSubChild,
                                  status: false,
                                })
                              }
                              masCatId={data[3]}
                              masterId={subData[0]}
                              childId={editSubChild?.data[2]}
                              handleCalbackData={handleCalbackData}
                              catIndex={i}
                              subCatIndex={j}
                              formName="phoneNote"
                              heading={subData[1]}
                              cat={editSubChild?.data[3]}
                            />
                          )}
                        </div>
                        <CounselingSecColSubChild
                          data={data}
                          subData={subData}
                          checkBoxData={checkBoxData}
                          handleCheckBoxChange={handleCheckBoxChange}
                          handleRemoveSubChild={handleRemoveSubChild}
                          handleEditSubChild={handleEditSubChild}
                          moduleName={'ptc'}
                          checkboxRef={checkboxRef}
                          handleCheckBoxLable={handleCheckBoxLable}
                          allData={allData}
						  editModeEnabled={true}
                        />
                      </div>
                    ))}
                </div>
              ))}
            </div>

            <div className="asmnt-childblk childblk2 blk2-col3">
              {allData?.therapyMasterData?.map((data, i) => (
                <div key={i}>
                  {data[2]?.map((subData, j) => (
                    <div
                      key={j}
                      className={`grid-sec ${
                        showHideChiled === data[3] + '_' + subData[0]
                          ? ''
                          : 'hide'
                      }`}
                      ref={(el) =>
                        (scrollRefs.current[
                          'therapyDetailsText_' + data[3] + '_' + subData[0]
                        ] = el)
                      }
                    >
                      <span className="pop-up-sb-hdr hide">{subData[1]}</span>
                      <textarea
                        className="cnslng-poup-txtrea"
                        placeholder="Write here..."
                        id={'therapyDetailsText_' + data[3] + '_' + subData[0]}
                        name={
                          'therapyDetailsText_' + data[3] + '_' + subData[0]
                        }
                        spellCheck="true"
                        value={
                          textAreaData &&
                          textAreaData[
                            'therapyDetailsText_' + data[3] + '_' + subData[0]
                          ]
                        }
                        onChange={handleInputChange}
                      ></textarea>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div
          className="asmnt-prnt-blk-ftr"
          style={{ width: '100%', padding: '5px 0px', float: 'left' }}
        >
          <span
            className="actn-No right clear-right width-unset"
            onClick={handleClose}
          >
            Cancel
          </span>
          {(allData.mode === 'add' && (
            <span
              className="actn-yes right clear-right clear-left width-unset"
              onClick={handleNoteFormSave}
            >
              Save
            </span>
          )) ||
            (allData.mode === 'update' && (
              <span
                className="actn-yes right clear-right clear-left width-unset"
                onClick={handleNoteFormUpdate}
              >
                Update
              </span>
            ))}
        </div>
        {removeSubChild && (
          <ConfirmDialog
            bodytext={'Do you want to remove it?'}
            closeDialog={() => setRemoveSubChild(false)}
            successDialog={handleRemoveSubChildConfirm}
            sucPrams={sucPrams}
          />
        )}
        {subTypePopup && (
          <SubTypePopup
            closeDialog={() => setSubTypePopup(false)}
            subChildPrams={subChildPrams}
            callBack={handlesubtypeform}
            form={'custom_counseling1'}
          />
        )}
      </div>
    </div>
  );
}

export default AddNote;
